<template>
	<div class="user-center-container profile-container">
		<div class="user-center-header user-header">
			<div class="user-avatar">
				<img src="@/assets/user/user-avator.png" alt="用户头像" />
				<div class="user-info">
					<div class="user-name">
						<span class="realName">{{ userForm.realName || '暂未登录' }}</span>
						<span v-if="isVip || isSVip" class="level-tag" :class="{ 'vip-tag': isVip, 'svip-tag': isSVip }"></span>
					</div>
					<span class="login-days">楚建通已陪伴您{{ userForm.registerTime }}天</span>
				</div>
			</div>
			<div class="user-status">
				<div class="vip-info">
					<div v-if="isVip || isSVip" class="vip-card" :class="{ 'svip-card': isSVip }">
						<span>{{ isVip ? 'VIP会员' : isSVip ? 'SVIP会员' : '' }}</span>
						<div class="vip-time">
							<span class="expire-date">到期时间：{{ userForm.outTime }}</span>
							<span class="renew-btn" @click="handlePayVisible">立即续费</span>
						</div>
					</div>
					<div v-if="isVip" class="upgrade-card" @click="handleLocationMemberBenefits"></div>

					<div v-if="isNormalVip" class="vip-card normal-vip" @click="handleLocationMemberBenefits">
						<span>立即成为会员</span>
					</div>

					<div class="log-off">
						<el-button @click="handleLogOff">注销账号</el-button>
					</div>
				</div>
			</div>
		</div>

		<div class="user-center-content profile-form">
			<div class="form-header">
				<h3 class="form-title">我的资料</h3>
			</div>

			<el-form label-width="160px" size="medium">
				<el-form-item label="昵称">
					<div class="form-item-content">
						<el-input v-model="userForm.realName" disabled></el-input>
						<span class="tools" @click="handleUpdateUserInfo('2')">修改</span>
					</div>
				</el-form-item>

				<el-form-item label="手机号">
					<div class="form-item-content">
						<el-input v-model="userForm.phone" disabled></el-input>
						<span class="tools" @click="handleUpdateUserInfo('3')">更换</span>
					</div>
				</el-form-item>

				<el-form-item label="邮箱">
					<div class="form-item-content">
						<el-input v-model="userForm.email" disabled></el-input>
						<span class="tools" @click="handleUpdateUserInfo('5')">绑定邮箱</span>
					</div>
				</el-form-item>

				<el-form-item label="密码">
					<div class="form-item-content">
						<el-input v-model="userForm.password" type="password" disabled show-password></el-input>
						<span class="tools" @click="handleUpdateUserInfo('4')">修改</span>
					</div>
				</el-form-item>
			</el-form>
		</div>

		<!-- 修改用户信息弹窗 -->
		<jr-dialog :visible.sync="updateUserVisible" @close="handleCloseUpdate">
			<template slot="title">
				<!-- 自定义弹窗标题 -->
				<h4 class="model-title">
					<span>{{ userUpdateTitle }}</span>
				</h4>
			</template>
			<template slot="content">
				<div class="form-content">
					<el-form ref="updateUserForm" :model="updateUserForm" :rules="rules" label-width="150px">
						<!-- 修改用户昵称 -->
						<template v-if="userUpdateType === '2'">
							<el-form-item label="昵称：" prop="realName" class="form-item">
								<el-input v-model="updateUserForm.realName" placeholder="请输入昵称">
									<span slot="prefix" class="svg-container"><svg-icon icon-class="user" /></span>
								</el-input>
							</el-form-item>
						</template>
						<!-- 修改用户手机号 -->
						<template v-else-if="userUpdateType === '3'">
							<el-form-item label="登录密码：" prop="password" class="form-item">
								<el-input v-model="updateUserForm.password" type="password" placeholder="请输入登录密码">
									<span slot="prefix" class="svg-container"><svg-icon icon-class="password" /></span>
								</el-input>
							</el-form-item>
							<el-form-item label="新手机号：" prop="phone" class="form-item">
								<el-input v-model="updateUserForm.phone" placeholder="请输入新手机号">
									<span slot="prefix" class="svg-container"><svg-icon icon-class="mobile" /></span>
								</el-input>
							</el-form-item>
						</template>
						<!-- 修改用户登录密码 -->
						<template v-else-if="userUpdateType === '4'">
							<el-form-item label="密码：" prop="password" class="form-item">
								<el-input v-model="updateUserForm.password" :type="passwordType" placeholder="请输入原密码">
									<span slot="prefix" class="svg-container"><svg-icon icon-class="password" /></span>
								</el-input>
								<span class="show-pwd svg-container" @click="showPwd">
									<svg-icon :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'" />
								</span>
							</el-form-item>
							<el-form-item label="新密码：" prop="newPassword1" class="form-item">
								<el-input v-model="updateUserForm.newPassword1" :type="passwordType2" placeholder="请输入6-18位数字字母新密码">
									<span slot="prefix" class="svg-container"><svg-icon icon-class="password" /></span>
								</el-input>
								<span class="show-pwd svg-container" @click="showPwd2">
									<svg-icon :icon-class="passwordType2 === 'password' ? 'eye' : 'eye-open'" />
								</span>
							</el-form-item>
							<el-form-item label="确认密码：" prop="newPassword2" class="form-item">
								<el-input v-model="updateUserForm.newPassword2" :type="passwordType3" placeholder="请再次输入密码">
									<span slot="prefix" class="svg-container"><svg-icon icon-class="password" /></span>
								</el-input>
								<span class="show-pwd svg-container" @click="showPwd3">
									<svg-icon :icon-class="passwordType3 === 'password' ? 'eye' : 'eye-open'" />
								</span>
							</el-form-item>
						</template>
						<!-- 绑定邮箱 -->
						<template v-else-if="userUpdateType === '5'">
							<el-form-item label="登录密码：" prop="password" class="form-item">
								<el-input v-model="updateUserForm.password" type="password" placeholder="请输入登录密码">
									<span slot="prefix" class="svg-container"><svg-icon icon-class="password" /></span>
								</el-input>
							</el-form-item>
							<el-form-item label="邮箱：" prop="email" class="form-item">
								<el-input v-model="updateUserForm.email" placeholder="请输入邮箱">
									<span slot="prefix" class="svg-container"><svg-icon icon-class="mail" /></span>
								</el-input>
							</el-form-item>
						</template>
					</el-form>
				</div>
			</template>
			<template slot="footer">
				<el-button type="primary" @click="handleSaveUserInfo">确 定</el-button>
			</template>
		</jr-dialog>

		<!-- 账号注销弹窗 -->
		<jr-dialog :visible.sync="userLogOffVisible" :show-btn="false">
			<template slot="title">
				<!-- 自定义弹窗标题 -->
				<h4 class="model-title">
					<span>账号注销</span>
				</h4>
			</template>
			<template slot="content">
				<div class="logOffContainer">
					<h3>账号注销须知</h3>
					<p>1、账号注销后，您将无法登录或使用该账号，同时无法享受以该账号登录使用楚建通提供的所有产品和服务。</p>
					<p>
						2、账号注销后，包括但不限于您账号下绑定的个人信息、会员信息、会员权益、认证信息、收藏信息、订单信息等信息会同步删除且无法恢复。
					</p>
					<p>3、申请账号注销后，客服会在10个工作日内完成账号注销。</p>
					<p>您若需要注销账号，可通过联系客服申请处理。</p>

					<div class="btn-group">
						<el-button @click="userLogOffVisible = false">取消</el-button>
						<el-button type="primary" @click="openQQService">在线QQ申请</el-button>
					</div>
				</div>
			</template>
		</jr-dialog>

		<!-- 购买会员弹窗 -->
		<jr-dialog :visible.sync="payVisible" width="840px" :show-btn="false" @close="payVisible = false">
			<template slot="title">
				<!-- 自定义弹窗标题 -->
				<h4 class="model-title">
					<span>购买会员</span>
				</h4>
			</template>
			<template slot="content">
				<payment-dialog :active-vip-type="activeVipType" @payOrderSuccess="handlePayOrderSuccessCallback"></payment-dialog>
			</template>
		</jr-dialog>
	</div>
</template>

<script>
	// 个人资料
	import { getUserInfo } from '@/api/userCenter'
	import { updateUser } from '@/api/user'
	import JrDialog from '@/components/Dialog'
	import PaymentDialog from '@/views/memberBenefits/paymentDialog.vue'
	import { mapGetters } from 'vuex'
	import { validatePassword, validateMobile, validateEmail } from '@/utils/jr-validate'
	import defaultSettings from '@/settings'
	import QQService from '@/mixins/QQService'

	export default {
		name: 'UserProfile',
		components: {
			JrDialog,
			PaymentDialog
		},
		mixins: [QQService],
		props: {},
		data() {
			const validForcePassword = (rule, value, callback) => {
				if (value !== this.updateUserForm.newPassword1) {
					callback(new Error('两次输入密码不一致!'))
				} else {
					callback()
				}
			}

			return {
				// 修改用户信息弹窗
				updateUserVisible: false,
				userForm: {
					id: '',
					userName: '',
					realName: '',
					phone: '',
					email: '未绑定',
					password: '****************',
					// 已注册时间
					registerTime: '',
					// 会员过期时间
					outTime: ''
				},
				// 更改用户信息类型（2：修改用户昵称；3：修改用户手机号；4：修改密码，5：绑定邮箱）
				userUpdateType: '',
				// 用户信息更新表单
				updateUserForm: {
					realName: '',
					phone: '',
					email: '',
					password: '',
					newPassword1: '',
					newPassword2: ''
				},
				rules: {
					realName: [{ required: true, message: '请输入昵称', trigger: 'blur' }],
					phone: [
						{ required: true, trigger: 'blur', message: '请输入手机号' },
						{ validator: validateMobile, trigger: 'blur' }
					],
					newPassword1: [
						{ required: true, message: '请输入新密码', trigger: 'blur' },
						{ validator: validatePassword, trigger: 'blur' }
					],
					newPassword2: [
						{ required: true, message: '请确认密码', trigger: 'blur' },
						{ validator: validForcePassword, trigger: 'blur' }
					],
					password: [
						{ required: true, message: '请输入密码', trigger: 'blur' },
						{ validator: validatePassword, trigger: 'blur' }
					],
					email: [
						{ required: true, message: '请输入邮箱', trigger: 'blur' },
						{ validator: validateEmail, trigger: 'blur' }
					]
				},

				// 账号注销弹窗
				userLogOffVisible: false,
				passwordType: 'password',
				passwordType2: 'password',
				passwordType3: 'password',

				// 购买会员弹窗
				payVisible: false,
				// 当前需购买的会员类型
				activeVipType: ''
			}
		},
		computed: {
			// 根据不同的修改类型返回对应的弹窗标题
			userUpdateTitle() {
				const titleMap = {
					'2': '修改昵称',
					'3': '更换手机号',
					'4': '修改密码',
					'5': '绑定邮箱'
				}
				return titleMap[this.userUpdateType] || '修改用户信息'
			},
			...mapGetters(['vipLevel', 'isNormalVip', 'isVip', 'isSVip'])
		},
		watch: {},
		created() {},
		mounted() {
			this.handleGetUserInfo()
		},
		methods: {
			// 获取登录用户信息
			handleGetUserInfo() {
				getUserInfo().then(response => {
					console.log(response)
					const { data } = response
					this.userForm.id = data.id
					this.userForm.userName = data.sysUserVO.userName
					this.userForm.email = data.sysUserVO.email
					this.userForm.realName = data.realName
					this.userForm.phone = data.phone
					this.userForm.registerTime = data.registerTime
					this.userForm.outTime = data.memberRecordList[0].outTime
				})
			},

			// 修改用户信息
			handleUpdateUserInfo(type) {
				this.userUpdateType = type
				this.updateUserVisible = true
			},

			// 关闭弹窗
			handleCloseUpdate() {
				this.updateUserVisible = false
				this.$refs.updateUserForm.resetFields()
			},

			// 保存修改的用户信息
			handleSaveUserInfo() {
				this.$refs.updateUserForm.validate(valid => {
					if (valid) {
						const data = {
							updateType: this.userUpdateType,
							user: {
								id: this.userForm.id,
								userName: this.userForm.userName,
								...this.updateUserForm
							}
						}
						updateUser(data)
							.then(response => {
								this.$modal.msgSuccess('修改成功')
								this.updateUserVisible = false
								if (this.userUpdateType === '2' || this.userUpdateType === '5') {
									this.$store.dispatch('user/getUserInfo')
									this.handleGetUserInfo()
								} else {
									setTimeout(() => {
										this.$store.dispatch('user/logout').then(() => {
											location.href = defaultSettings.publicPath + '/login'
										})
									}, 500)
								}
							})
							.catch(error => {
								console.log(error)
							})
					}
				})
			},

			// 账号注销
			handleLogOff() {
				this.userLogOffVisible = true
			},

			// 跳转会员权益办理页面
			handleLocationMemberBenefits() {
				this.$router.push({
					path: '/member-benefits'
				})
			},

			// 在线QQ
			handleOnlineQQ() {
				this.$modal.msgWarning('暂未接入客服QQ')
			},
			showPwd() {
				if (this.passwordType === 'password') {
					this.passwordType = ''
				} else {
					this.passwordType = 'password'
				}
			},
			showPwd2() {
				if (this.passwordType2 === 'password') {
					this.passwordType2 = ''
				} else {
					this.passwordType2 = 'password'
				}
			},
			showPwd3() {
				if (this.passwordType3 === 'password') {
					this.passwordType3 = ''
				} else {
					this.passwordType3 = 'password'
				}
			},
			// 打开企点客服
			openQQService() {
				this.handleEvokeQQ()
			},

			// 立即续费
			handlePayVisible() {
				// 确认需要续费的会员类型
				this.activeVipType = this.isSVip ? 'svip' : 'vip'
				this.payVisible = true
			},

			// 订单创建成功回调
			handlePayOrderSuccessCallback() {
				this.payVisible = false
				this.$router.push({
					path: '/user/market/order'
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '~@/views/user/styles/user-center.scss';
	@import '~@/styles/element-reset.scss';

	.profile-container {
		.user-header {
			display: flex;
			align-items: center;
			justify-content: space-between;

			.user-avatar {
				position: relative;
				margin-right: 20px;
				display: flex;
				justify-content: flex-start;
				align-items: center;

				img {
					width: 80px;
					height: 80px;
					border-radius: 50%;
					margin-right: 20px;
				}

				.user-info {
					.user-name {
						color: #333333;
						font-size: 20px;
						font-weight: bold;
						margin-bottom: 15px;
					}

					.login-days {
						font-size: 16px;
						color: #999999;
						font-weight: normal;
					}
				}

				.level-tag {
					display: inline-block;
					width: 25px;
					height: 20px;
					margin-left: 6px;
					vertical-align: bottom;
				}

				.vip-tag {
					background-image: url('~@/assets/vip/vip-tag-small.png');
					background-repeat: no-repeat;
					background-position: center;
					background-size: 100%;
				}

				.svip-tag {
					background-image: url('~@/assets/vip/svip-tag-small.png');
					background-repeat: no-repeat;
					background-position: center;
					background-size: 100%;
				}
			}

			.user-status {
				// flex: 1;

				.vip-info {
					display: flex;
					align-items: center;

					.vip-card,
					.upgrade-card {
						width: 273px;
						height: 86px;
						padding: 10px 20px;
						border-radius: 4px;
						display: flex;
						flex-direction: column;
					}

					.vip-card {
						background-image: url('~@/assets/user/vip-card.jpg');
						background-repeat: no-repeat;
						background-position: center;

						&.svip-card {
							background-image: url('~@/assets/user/svip-card.jpg');
						}

						&.normal-vip {
							justify-content: center;
							cursor: pointer;
						}

						span {
							font-size: 20px;
							color: #934e25;
						}

						.vip-time {
							display: flex;
							justify-content: space-between;
							margin-top: 15px;
						}

						span.expire-date {
							// margin-top: 15px;
							font-size: 16px;
						}

						span.renew-btn {
							color: #f2450a;
							font-size: 14px;
							font-weight: bold;
							// text-decoration: underline;
							padding: 0;
							transition: all 0.3s ease;
							cursor: pointer;
							&:hover {
								color: #f2450a;
								transform: translateY(-2px);
								box-shadow: 0 4px 12px rgba(255, 149, 56, 0.3);
							}
						}
					}

					.upgrade-card {
						margin-left: 20px;
						background-image: url('~@/assets/user/vip-up-card.jpg');
						background-repeat: no-repeat;
						background-position: center;
						cursor: pointer;
					}
				}

				.log-off {
					margin-left: 20px;
				}
			}
		}

		.profile-form {
			:deep(.el-form) {
				width: 700px;

				.el-form-item {
					margin-bottom: 16px;

					.el-form-item__label {
						color: #333;
						font-size: 16px;
						font-weight: normal;
						line-height: 48px;
					}

					.form-item-content {
						display: flex;
						align-items: center;

						.el-input {
							width: 400px;

							.el-input__inner {
								height: 48px;
								line-height: 48px;
								color: #666;
								background-color: #f5f7fa;
								font-size: 16px;
								padding-left: 30px;
							}
						}

						.tools {
							font-size: 16px;
							color: #2671cb;
							cursor: pointer;
							margin-left: 15px;
						}
					}
				}
			}
		}
	}

	.logOffContainer {
		h3 {
			color: #333333;
			font-size: 24px;
			line-height: 48px;
			text-align: center;
		}

		p {
			color: #999999;
			font-size: 16px;
			line-height: 2;
		}

		.btn-group {
			padding: 20px 0;
			text-align: center;

			.el-button {
				width: 180px;
			}
		}
	}
	.show-pwd {
		position: absolute;
		right: 10px;
		top: 0px;
		font-size: 16px;
		color: #3e8eff;
		cursor: pointer;
		user-select: none;
	}
</style>
